module.exports = __webpack_public_path__ + "static/assets/e52847c8f2fe3fec97150c9928e21975.svg";